import { useMutation } from 'react-query';
import * as subscriptionService from 'services/subscriptionService';

export const useCancelSubscription = (onSuccess: any, onError: any, options = {}) => {
  return useMutation(subscriptionService.cancelSubscription, {
    onSuccess,
    onError,
    ...options,
  })
}

export const useCreateSubscription = (onSuccess: any, onError: any, options = {}) => {
  return useMutation(subscriptionService.createSubscription, {
    onSuccess,
    onError,
    ...options,
  })
}

export const useUpdateSubscription = (onSuccess: any, onError: any, options = {}) => {
  return useMutation(subscriptionService.UpdateSubscription, {
    onSuccess,
    onError,
    ...options,
  })
}